import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar"]
  static values = { percent: Number }

  connect() {
    this.barTarget.style.width = `${this.percentValue}%`
  }

  percentValueChanged() {
    this.barTarget.style.width = `${this.percentValue}%`
  }
}
